/*
* Copyright (c) 2017 Honeywell International, Inc. All rights reserved.
*
* This file contains trade secrets of Honeywell International, Inc.  No part
*  may be reproduced or transmitted in any form by any means or for any
*  purpose without the express written permission of Honeywell.
*
*/

import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';

@Injectable()
export class EBIService {
    api_url: any;

    constructor(private apiService: ApiService) {
        this.api_url = environment.cdt.api_url;
    }

    getFileData(fileType: string) {
        return this.apiService.get('contextDiscovery/file/' + fileType, this.api_url);
    }
}
